import { useContext } from "react"
import { useNavigate, Link } from "react-router-dom"

import UserContext from "../../context/userContext"
import CartContext from "../../context/cartContext"

const AccDropdown = () => {
  const navigate = useNavigate()

  const { user, setUser } = useContext(UserContext)
  const { setCart } = useContext(CartContext)

  /* ---------------------------
     Logout
  --------------------------- */
  const logout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
        method: "POST",
        credentials: "include",
      })
    } finally {
      setUser(null)
      setCart(null)
      navigate("/login")
    }
  }

  /* ---------------------------
     Not logged in
  --------------------------- */
  if (!user) {
    return (
      <li className="nav-item">
        <div className="dropdown-center">
          <div
            className="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
          >
            Account
          </div>

          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/login">
                Sign in
              </Link>
            </li>
          </ul>
        </div>
      </li>
    )
  }

  /* ---------------------------
     Logged in
  --------------------------- */
  return (
    <li className="nav-item d-flex align-items-end">
      <div className="dropdown-center">
        <div
          className="nav-link dropdown-toggle d-flex align-items-center"
          role="button"
          data-bs-toggle="dropdown"
        >
          Hello,&nbsp;{user.username}
        </div>

        <ul className="dropdown-menu dropdown-menu-start text-center me-5">
          <li>
            <Link
              className="dropdown-item"
              to="/account"
              state={{ tab: "home" }}
            >
              Your Account
            </Link>
          </li>

          <li>
            <Link
              className="dropdown-item"
              to="/account"
              state={{ tab: "orders" }}
            >
              Your Orders
            </Link>
          </li>

          <li>
            <Link
              className="dropdown-item"
              to="/account"
              state={{ tab: "lists" }}
            >
              Your Lists
            </Link>
          </li>

          <li>
            <Link
              className="dropdown-item"
              to="/account"
              state={{ tab: "settings" }}
            >
              Settings
            </Link>
          </li>

          <li>
            <button className="dropdown-item text-danger" onClick={logout}>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </li>
  )
}

export default AccDropdown
